import './acaoexecutada.scss'

const acaoexecutada = ({ acao, participantes, catoutop, nls }) => {
  if (!acao) return null

  const acoes = Array.isArray(acao.acoes) ? acao.acoes : []

  const obterAcoesExecutadas = () => {
    if (acao.tipo === 'personalizada') {
      return acoes.slice(0, 1)
    }

    if (acao.tipo === 'padrao') {
      if (catoutop === 'cat') {
        return acoes
      }

      if (catoutop === 'top') {
        return acoes.filter(item => Number(item?.ehescolhida) === 1)
      }
    }

    return []
  }

  const acoesExecutadas = obterAcoesExecutadas()
  const responsavel = acao?.responsavel_executar || null
  const participantesValidos = Array.isArray(participantes) ? participantes : []

  if (!acoesExecutadas.length && !responsavel && !participantesValidos.length) {
    return null
  }

  const obterNomeCompleto = pessoa => {
    if (!pessoa) return ''
    return [pessoa.nome, pessoa.sobrenome].filter(Boolean).join(' ')
  }

  const obterStatusConfirmacao = status => {
    if (status === 0) return nls.confirmationPending
    if (status === 1) return nls.confirmationAccepted
    if (status === -1) return nls.confirmationRejected
    return null
  }

  const tipoAcaoLabel =
    acao.tipo === 'personalizada'
      ? nls.actionTypeCustom
      : nls.actionTypeStandard

  return (
    <div
  className='acaoexecutada'
  data-cy='pdca-plan-detail-executed-action'
>
      <div className='acaoexecutada__title'>
        {nls.executedActionTitle.toUpperCase()}
      </div>

      <div className='acaoexecutada__content'>
        <div className='acaoexecutada__type'>
          <span className='acaoexecutada__label'>
            {nls.actionTypeLabel}
          </span>
          <strong className='acaoexecutada__value'>
            {tipoAcaoLabel}
          </strong>
        </div>

        {acoesExecutadas.length > 0 && (
          <div
  className='acaoexecutada__list'
  data-cy='pdca-plan-detail-executed-actions-list'
>
            {acoesExecutadas.map((item, index) => (
              <div
  key={`acao-executada-${index}`}
  className='acaoexecutada__card'
  data-cy='pdca-plan-detail-executed-action-item'
>
                {item?.titulo && (
                  <div className='acaoexecutada__field'>
                    <span className='acaoexecutada__label'>
                      {nls.actionTitleLabel}
                    </span>
                    <strong className='acaoexecutada__value'>
                      {item.titulo}
                    </strong>
                  </div>
                )}

                {acao.tipo === 'personalizada' && item?.descricao && (
                  <div className='acaoexecutada__field'>
                    <span className='acaoexecutada__label'>
                      {nls.actionDescriptionLabel}
                    </span>
                    <strong className='acaoexecutada__value acaoexecutada__value--text'>
                      {item.descricao}
                    </strong>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        {responsavel && (
          <div
  className='acaoexecutada__responsible'
  data-cy='pdca-plan-detail-responsible'
>
            <span className='acaoexecutada__label'>
              {nls.executionResponsibleLabel}
            </span>
            <strong className='acaoexecutada__value'>
              {obterNomeCompleto(responsavel)}
            </strong>
          </div>
        )}

        {participantesValidos.length > 0 && (
          <div
  className='acaoexecutada__participants'
  data-cy='pdca-plan-detail-participants'
>
            <div className='acaoexecutada__participants-title'>
              {nls.participantsTitle}
            </div>

            <div className='acaoexecutada__participants-list'>
              {participantesValidos.map((item, index) => {
                const statusLabel = obterStatusConfirmacao(item?.status_confirmacao)

                return (
                  <div
  key={`participante-${index}`}
  className='acaoexecutada__participant-card'
  data-cy='pdca-plan-detail-participant'
>
                    {obterNomeCompleto(item) && (
                      <div className='acaoexecutada__field'>
                        <span className='acaoexecutada__label'>
                          {nls.participantNameLabel}
                        </span>
                        <strong className='acaoexecutada__value'>
                          {obterNomeCompleto(item)}
                        </strong>
                      </div>
                    )}

                    {statusLabel && (
                      <div className='acaoexecutada__field'>
                        <span className='acaoexecutada__label'>
                          {nls.confirmationStatusLabel}
                        </span>
                        <strong className='acaoexecutada__value'>
                          {statusLabel}
                        </strong>
                      </div>
                    )}

                    {item?.data_resposta && (
                      <div className='acaoexecutada__field'>
                        <span className='acaoexecutada__label'>
                          {nls.responseDateLabel}
                        </span>
                        <strong className='acaoexecutada__value'>
                          {item.data_resposta}
                        </strong>
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default acaoexecutada